// src/features/Setting/Melting_Requests/api/meltingRequestApi.js
import { useQuery } from "@tanstack/react-query";
import apiClient from "lib/api-client";


// Fetch single melting request by ID
const fetchBinnysCompanyClient = async (enabled) => {
    try {
        const response = await apiClient.get("/api/v9/myBinnys/myBinnysClientCompanyNames");
        return response?.data;
    } catch (error) {
        console.error("Error fetching client list:", error);
        return [];
    }
};

export const useBinnysCompanyClient = ({enabled}) => {
    return useQuery({
        queryKey: ["binnys-company-client"],
        queryFn: fetchBinnysCompanyClient,
        enabled:!!enabled,
        staleTime: 5 * 60 * 1000,
        cacheTime: 5 * 60 * 1000,
    });
};

const fetchLiveStreamClient = async ({catalogId}) => {
    try {
        const response = await apiClient.post("/api/v1/catalog/liveStream", {catalogId});
        return response?.data;
    } catch (error) {
        console.error("Error fetching client list:", error);
        return [];
    }
};

export const useLiveStreamClient = ({catalogId}) => {
    return useQuery({
        queryKey: ["live-stream-client", catalogId],
        queryFn: () => fetchLiveStreamClient({catalogId}),
        enabled:!!catalogId,
        staleTime: 5 * 60 * 1000,
        cacheTime: 5 * 60 * 1000,
    });
};

export default {
    useBinnysCompanyClient,
    useLiveStreamClient,
};